enum FormButtonType {
  Default = 'default',
  Continue = 'continue'
}

export default FormButtonType
